module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bill"
  }, [_c('div', {
    staticClass: "billtop"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('fangTXQ_bill')))]), _vm._v(" "), (_vm.isJingJiang && _vm.jjAccountAdjust) ? _c('span', {
    staticClass: "ext-btn",
    on: {
      "click": _vm.goInsertBill
    }
  }, [_vm._v(_vm._s(_vm.$t('JJ_AccountIn_title')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "billContent"
  }, [_c('ul', {
    staticClass: "billList clearfix"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_masterBase')) + ":\n        "), _c('span', [_vm._v(_vm._s((_vm.orderInfo.fMasterDto.masterBase.charge - _vm.orderInfo.fMasterDto.masterBase.pay).toFixed(2)))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_credit')) + ":\n        "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.credit.toFixed(2)))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_othBalance')) + ":\n        "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.othBalance.toFixed(2)))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_othCredit')) + ":\n        "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.othCredit.toFixed(2)))])]), _vm._v(" "), (_vm.orderInfo.fMasterDto.masterBase.coMsg) ? _c('li', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('fangTXQ_coMsg')) + "："), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.fMasterDto.masterBase.coMsg))])]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "itemsList"
  }, [_c('tr', {
    staticClass: "category"
  }, [_c('th', {
    attrs: {
      "width": "36px"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('fangTXQ_rmno')))])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "108px"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('fangTXQ_project')))])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "64px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('fangTXQ_time')))])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "68px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('fangTXQ_operator')))])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "50px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('fangTXQ_amount')))])])]), _vm._v(" "), _vm._l((_vm.orderInfo.acclist), function(val, key) {
    return _c('tr', {
      key: key,
      staticClass: "item"
    }, [_c('td', [_vm._v(_vm._s(val.rmno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.taDescript))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm._f("dateD")(val.genDate)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.createUser))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.arrangeCode.indexOf('9') == 0 ? val.pay : val.charge))])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5084b65c","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/fangTXQ/fangTXQ-comp/bill.vue
// module id = 1787
// module chunks = 107